import { CSSResultGroup, html, LitElement } from 'lit'
import { customElement, query, property } from 'lit/decorators.js'
import { t } from '@cloudsuite/mosaic-shared/translations/translator.js'
import { CSESlideIn } from '@cloudsuite/mosaic-elements'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import 'components/discovery/pdp/store-stock/store-stock.js'

export const storeStockSlideInLinkVariants = ['primary', 'secondary', 'white'] as const
export type StoreStockSlideInLinkVariantType = typeof storeStockSlideInLinkVariants

export const storeStockSlideInSizes = ['default', 'small'] as const
export type StoreStockSlideInSizeType = typeof storeStockSlideInSizes

@customElement('csc-store-stock-slide-in')
export class CSCStoreStockSlideIn extends LitElement {
  static override styles: CSSResultGroup = [hostStyle]

  @property({ type: String, attribute: 'link-variant' })
  linkVariant: StoreStockSlideInLinkVariantType[number] = 'secondary'

  @property({ type: String })
  size: StoreStockSlideInSizeType[number] = 'default'

  @property({ type: Number, attribute: 'product-id' })
  productId!: number

  @property({ type: String, attribute: 'country-code' })
  countryCode = ''

  @property({ type: String, attribute: 'maps-key' })
  mapsKey = ''

  @query('cse-slide-in')
  slideIn!: CSESlideIn

  open() {
    this.slideIn.open()
  }

  override render() {
    return html`
      <slot name="trigger" @click="${this.open}">
        <cse-link
          variant="${this.linkVariant}"
          font-variant="${this.size === 'small' ? 'body-s' : 'body'}"
        >
          <slot></slot>
        </cse-link>
      </slot>

      <cse-slide-in size="default" placement="right">
        <div slot="header">
          ${t('slide_in_header', { ns: 'csc-store-stock-slide-in', default: 'Store stock' })}
        </div>
        <csc-store-stock
          product-id="${this.productId}"
          country-code="${this.countryCode}"
          maps-key="${this.mapsKey}"
        ></csc-store-stock>
      </cse-slide-in>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'csc-store-stock-slide-in': CSCStoreStockSlideIn
  }
}
